var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAccess)?_c('layout',[_c('template',{slot:"content"},[_c('ini-content-title',{attrs:{"title":_vm.title,"icon":"facture"}}),_c('ini-invoice-list',{attrs:{"entries":_vm.entries,"title":_vm.title}})],1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }